module.exports = __webpack_public_path__ + "img/background.dd0700c1.png";